import i18n from 'i18next'
import { getSystemLanguage } from '@/shared/getSystemLanguage'

const NORWEGIAN = ['nb', 'nn', 'no']

/**
 * Initial headline for a new factbox ("Fakta:"), in the document's language rather than the UI's.
 * No language falls back to the system language; a language without a translation gives ''.
 */
export function getFactboxNewTitle(language?: string): string {
  const base = toBaseLanguage(language || getSystemLanguage())
  const prefix = i18n.getResource(base, 'editor', 'factbox.factboxNewTitle') as string | undefined

  if (!prefix) {
    return ''
  }

  return `${prefix}:`
}

function toBaseLanguage(language: string): string {
  const base = language.toLowerCase().split('-')[0]

  return NORWEGIAN.includes(base) ? 'nb' : base
}
